export const csrfHeaderName = "X-IWS-CSRF-PROTECTION";
export const csrfHeaderValue = "Anti-CSRF";

export function addAntiCsrfHeader(request: XMLHttpRequest): void {
    request.setRequestHeader(csrfHeaderName, csrfHeaderValue)
}

window.addAntiCsrfHeader = addAntiCsrfHeader;
window.csrfHeaderName = csrfHeaderName;
window.csrfHeaderValue = csrfHeaderValue;
